query SalesAnalyticsGetClient(
  $clientId: String!
) {
  analyticsMetafields: SalesAnalyticsGetClient(
    clientId: $clientId
  ) {
    projects {
      id: projectId
      title: projectName
    }
    products {
      id: productId
      title: productName
    }
    bundles {
      id: productId
      title: productName
      components: childProductIds
    }
  }
}